import twttr from "twitter-text";
export function uuid() {
  return (((1 + Math.random()) * 0x10000) | 0).toString(16).substring(1);
}

export function guid() {
  return (
    uuid() +
    uuid() +
    "-" +
    uuid() +
    "-" +
    uuid() +
    "-" +
    uuid() +
    "-" +
    uuid() +
    uuid() +
    uuid()
  );
}

/**
 * 点击其他元素自动隐藏
 * @param ref 需要监听的元素
 * @param ref 点击其他元素后的回调
 */
export function autoHide({ ref, callback }) {
  // 点击其他区域消失
  window.document.addEventListener("click", (e) => {
    if (!ref.contains(e.target)) {
      callback();
    }
  });
  window.document.addEventListener("input", (e) => {
    if (!ref.contains(e.target)) {
      callback();
    }
  });
}

/**
 * promise 版的setTimeout
 * @param time
 * @returns {Promise<any>}
 */
export function sleep({ time }) {
  return new Promise((resolve) => {
    setTimeout(() => {
      resolve();
    }, time);
  });
}

/**
 * 为元素添加事件，并且覆盖老事件
 * @param el 触发的元素
 * @param event 触发的事件名称
 * @param callback 事件触发的回调
 */
export function addOnlyEvent({ el, event, callback }) {
  const elClone = el.cloneNode(true);
  el.parentNode.replaceChild(elClone, el);
  el.addEventListener(event, () => {
    callback();
  });
}

/**
 * 生成从minNum到maxNum的随机数
 * @param minNum 最小值
 * @param maxNum 最大值
 * @return {number}
 */
export function randomNum(minNum, maxNum) {
  if (minNum === maxNum) {
    return minNum;
  }
  switch (arguments.length) {
    case 1:
      return parseInt(Math.random() * minNum + 1, 10);
    case 2:
      return parseInt(Math.random() * (maxNum - minNum + 1) + minNum, 10);
    default:
      return 0;
  }
}

/**
 * 获取设备
 * @return {string}
 */
export function getDevice() {
  const u = navigator.userAgent;
  const isAndroid = u.indexOf("Android") > -1 || u.indexOf("Adr") > -1; // android终端
  const isiOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/); // ios终端
  if (isAndroid) {
    return "android";
  } else if (isiOS) {
    return "ios";
  } else {
    return "web";
  }
}
export function getQueryString(name) {
  var reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)", "i");
  var r = window.location.search.substr(1).match(reg);
  if (r != null) {
    return unescape(r[2]);
  }
  return null;
}
/**
 * 从文案中提取url
 * @param s 待提取的文案
 */
export function httpString(s) {
  // var reg = /(http:\/\/|https:\/\/)((\w|=|\?|\.|\/|&|-)+)/g
  // var reg = /^(https?:\/\/)?([\da-z\.-]+)\.([a-z\.]{2,6})([\/\w \.-]*)*\/?$/;
  // var reg=/(http(s)?\:\/\/)?(www\.)?(\w+\:\d+)?(\/\w+)+\.(swf|gif|jpg|bmp|jpeg)/gi;
  // var reg=/(http(s)?\:\/\/)?(www\.)?(\w+\:\d+)?(\/\w+)+\.(swf|gif|jpg|bmp|jpeg)/gi;
  // eslint-disable-next-line
  const reg =
    /(((http|ftp|https):\/{2})?(([0-9a-z_-]+\.)+(aero|asia|biz|cat|com|coop|edu|gov|info|int|jobs|mil|mobi|museum|name|net|org|pro|tel|travel|ac|ad|ae|af|ag|ai|al|am|an|ao|aq|ar|as|at|au|aw|ax|az|ba|bb|bd|be|bf|bg|bh|bi|bj|bm|bn|bo|br|bs|bt|bv|bw|by|bz|ca|cc|cd|cf|cg|ch|ci|ck|cl|cm|cn|co|cr|cu|cv|cx|cy|cz|cz|de|dj|dk|dm|do|dz|ec|ee|eg|er|es|et|eu|fi|fj|fk|fm|fo|fr|ga|gb|gd|ge|gf|gg|gh|gi|gl|gm|gn|gp|gq|gr|gs|gt|gu|gw|gy|hk|hm|hn|hr|ht|hu|id|ie|il|im|in|io|iq|ir|is|it|je|jm|jo|jp|ke|kg|kh|ki|km|kn|kp|kr|kw|ky|kz|la|lb|lc|li|lk|lr|ls|lt|lu|lv|ly|ma|mc|md|me|mg|mh|mk|ml|mn|mn|mo|mp|mr|ms|mt|mu|mv|mw|mx|my|mz|na|nc|ne|nf|ng|ni|nl|no|np|nr|nu|nz|nom|pa|pe|pf|pg|ph|pk|pl|pm|pn|pr|ps|pt|pw|py|qa|re|ra|rs|ru|rw|sa|sb|sc|sd|se|sg|sh|si|sj|sj|sk|sl|sm|sn|so|sr|st|su|sv|sy|sz|tc|td|tf|tg|th|tj|tk|tl|tm|tn|to|tp|tr|tt|tv|tw|tz|ua|ug|uk|us|uy|uz|va|vc|ve|vg|vi|vn|vu|wf|ws|ye|yt|yu|za|zm|zw|arpa)(:[0-9]+)?((\/([~0-9a-zA-Z\#\+\%@\.\/_-]+))?(\?[0-9a-zA-Z\+\%@\/&\[\];=_-]+)?)?))\b/i;
  // var reg= /^((ht|f)tps?):\/\/[\w\-]+(\.[\w\-]+)+([\w\-\.,@?^=%&:\/~\+#]*[\w\-\@?^=%&\/~\+#])?$/;
  // v = v.replace(reg, "<a href='$1$2'>$1$2</a>"); //这里的reg就是上面的正则表达式
  // s = s.replace(reg, "$1$2"); //这里的reg就是上面的正则表达式
  s = s.match(reg);
  return s;
}
/**
 * 获取文字长度，twitter官方提供一个库用于计算长度，其他类型采用英文1个，中文2字逻辑计算
 * @param text 计算的问题
 * @param socialNetwork 类型 twitter特殊 别的都一样
 */
export function getTextLength({ text = "", socialNetwork = "instagram" }) {
  if (!text) {
    return 0;
  }
  if (socialNetwork === "twitter") {
    const params = twttr.parseTweet(text);
    if (params) {
      return params.weightedLength;
    }
  } else {
    const params = twttr.parseTweet(text);
    if (params) {
      return params.displayRangeEnd;
    }
    // 神奇的字数统计 改用twttr算了
    // let str_len = 0
    // if (text) {
    //   str_len = text.length
    //   // /n 算2字符
    //   const filter = text.split('\u2800').length - 1
    //   str_len += filter
    // }
    // 别问我为什么有下面的逻辑 一会说中文算2字 过2月又说算1个字 留着吧
    // let str_length = 0
    // let a
    // for (var i = 0; i < str_len; i++) {
    //   a = text.charAt(i)
    //   str_length++
    //   if (escape(a).length > 4) {
    //     // 中文字符的长度经编码之后大于4
    //     str_length++
    //   }
    // }
    // return str_length
    // return str_len
  }
  return 0;
}
